import { Fragment, useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import './navigation.styles.scss';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <Fragment>
      <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
        <Link className='logo-container' to='/'>
          <div className='logo'>
            <span className='logo-icon'>🗄️</span>
            <span className='logo-text'>Rmt-DBA</span>
          </div>
        </Link>
        
        <div className={`nav-links-container ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} 
            to='/'
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <span className='nav-icon'>🏠</span>
            Home
          </Link>
          <Link 
            className={`nav-link ${location.pathname.includes('/services') ? 'active' : ''}`} 
            to='/services'
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <span className='nav-icon'>🛠️</span>
            Services
          </Link>
          <Link 
            className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`} 
            to='/about'
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <span className='nav-icon'>👥</span>
            About
          </Link>
          <Link 
            className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} 
            to='/contact'
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <span className='nav-icon'>📞</span>
            Contact
          </Link>
          <div className='nav-cta'>
            <Link to='/contact'>
              <button className='cta-button'>Get Quote</button>
            </Link>
          </div>
        </div>

        <div className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;